/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Billing_Enabled_ExplainerInputs */



/**
* | output |
* | --- |
* | "Billing active — each closed month is drafted as a Lexware invoice by the nightly invoicing run." |
*
* @param {Partner_Admin_Billing_Enabled_ExplainerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_billing_enabled_explainer = /** @type {((inputs?: Partner_Admin_Billing_Enabled_ExplainerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Billing_Enabled_ExplainerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abrechnung aktiv — jeder abgeschlossene Monat wird vom nächtlichen Rechnungslauf als Lexware-Rechnungsentwurf angelegt.")
	return /** @type {LocalizedString} */ ("Billing active — each closed month is drafted as a Lexware invoice by the nightly invoicing run.")
});